/* -------------------------------------------------------------------------- */
/*                             Menu subitem style                             */
/* -------------------------------------------------------------------------- */

@import './pk-menu-subitem.variables';

:host {
  @apply block;
}

.pk-menu__submenu {
  @apply box-border flex w-full cursor-pointer items-center border-0 border-l-4 border-l-transparent bg-inherit no-underline;
  @apply [--pk-focus-offset-width:-4px] focus-visible:focus-outline;

  @media (hover: hover) and (pointer: fine) {
    @apply hover:bg-[--menu-subitem--hover-bg];
  }

  @apply font-regular text-[length:--menu-subitem--font-size] leading-m text-text-01;
  @apply px-[--menu-subitem--paddingX] py-[--menu-subitem--paddingY];

  border-bottom: var(--menu-subitem--border-bottom);
}

.level-3 {
  @apply pl-[calc(var(--menu-subitem--paddingX)_+_var(--pk-spacing-m))];

  &.selected {
    @apply font-semibold;
  }
}

.pk-menu__submenu.selected {
  @apply bg-[--menu-subitem--selected-bg];
}

.highlight {
  @apply border-l-4 border-solid border-l-transparent;

  &.bordered,
  &.selected {
    @apply border-l-interaction;
  }
}
